module.exports = __webpack_public_path__ + "img/about5.f43f3b64.png";